module.exports = __webpack_public_path__ + "img/18_slow_cooking_(white).e1927f35.svg";